import { useEffect, useRef } from "react";
import { Mixpanel } from "lib/mixpanel/mixpanel";

import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";

import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import { MIXPANEL_TOKEN } from "lib/constants";
import { useUserData } from "lib/store/user";

const SourcesCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  const mixpanelRef = useRef<Mixpanel | null>(null);
  const { userId } = useUserData();

  useEffect(() => {
    mixpanelRef.current = new Mixpanel(MIXPANEL_TOKEN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CardContainer id={`content__${id}`}>
      <Heading text={briefing.sourcesHeading} id={id} />
      <div className="grid gap-[16px] md:gap-[24px]">
        {Object.keys(briefing.sources).map((category, i) => {
          return (
            <div key={i}>
              <p className="text-[16px] font-[700] text-[#002EA5] md:text-[24px]">
                {category}
              </p>
              {briefing.sources[category].map((source, i) => (
                <p key={i} className="mt-[8px] text-[16px] md:text-[21px]">
                  <a
                    className="text-cerise"
                    href={source.url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      if (userId && mixpanelRef.current) {
                        mixpanelRef.current.track("Link Click", {
                          "Link Clicked": source.url,
                          Component: "Sources",
                          distinct_id: userId,
                        });
                      }
                    }}
                  >
                    {source.referenceNumber && (
                      <sup>{source.referenceNumber} </sup>
                    )}
                    {source.title}
                  </a>{" "}
                  <span>
                    |&nbsp;
                    {source.year
                      ? `${source.month && source.month + " "}${
                          source.year && source.year + " | "
                        }`
                      : ""}
                  </span>
                  {source.sourceName}
                </p>
              ))}
            </div>
          );
        })}
      </div>
    </CardContainer>
  );
};

export default SourcesCard;
